import { Card, Typography } from '@mui/material';
import React from 'react';

const SelectorInfoPanel: React.FC<{ text: string }> = ({ text }) => (
  <Card
    sx={{
      minWidth: { xs: '90px', sm: '100px' },
      padding: { xs: '2px', sm: '2px 8px' },
      textAlign: 'center',
      bgcolor: 'rgba(200, 200, 200, 0.3)',
      borderRadius: '4px',
      border: '1px solid white',
      height: '32px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Typography
      variant="body2"
      sx={{
        fontFamily: 'Bebas Neue',
        fontWeight: 'normal',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: { xs: '0.75rem', sm: '0.8rem' },
        letterSpacing: '0.5px',
      }}
    >
      {text}
    </Typography>
  </Card>
);

export default SelectorInfoPanel;
